import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { router } from '@/router'
import { queryClient } from '@/lib/react-query'
import { Loading } from '@/components'
import '@/i18n'

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Loading />}>
        <RouterProvider router={router} />
      </Suspense>
      {/* React Query DevTools - 僅在開發環境顯示 */}
      {/* {import.meta.env.DEV && (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      )} */}
    </QueryClientProvider>
  )
}

export default App
